import { useMemo } from 'react';
import { ProductType } from '../types';
import { getTooltipText, getSavingsText, calculateTotalSavings } from '../config/savingsConfig';

interface UseSavingsCalculatorReturn {
  tooltipText: string;
  getBenefitText: (slideId: string) => string | null;
  getTotalSavings: (slideId: string) => string;
}

/**
 * Hook per calcolare i risparmi dinamici in base al prodotto e ZIP flag
 */
export function useSavingsCalculator(
  productType?: ProductType,
  zipFlag?: boolean | null
): UseSavingsCalculatorReturn {
  // Tooltip text basato sul tipo di prodotto
  const tooltipText = useMemo(() => {
    return getTooltipText(productType);
  }, [productType]);

  // Funzione per ottenere il testo del beneficio per una slide
  const getBenefitText = useMemo(() => {
    return (slideId: string) => getSavingsText(slideId, productType, zipFlag);
  }, [productType, zipFlag]);

  // Funzione per ottenere il totale cumulativo per una slide
  const getTotalSavings = useMemo(() => {
    return (slideId: string) => calculateTotalSavings(slideId, productType, zipFlag);
  }, [productType, zipFlag]);

  return {
    tooltipText,
    getBenefitText,
    getTotalSavings,
  };
}


